import React from 'react'

import { Modal } from 'react-bootstrap';

import DomainManager from './DomainManager'

const RestrictionsModal = props => {
    if (!props.visible) return null

    return <Modal
        bsSize="large"
        animation={false}
        show={true}
        onHide={props.toggleModal}
    >
        <Modal.Header closeButton>
            <h4>Domain Restrictions</h4>
            <p>Add domain(s) that this Event is restricted to.</p>
            <p>In most cases we will automatically trim your URLs to be compliant with our system's requirements.</p>
            <b>Formatting Examples:</b>
            <ul>
                <li><i>No Protocols</i>: <b>invintus.com</b> rather than <b>https://www.invintus.com/</b></li>
                <li><i>No Pages or Subpaths</i>: <b>invintus.com</b> rather than <b>invintus.com/help/</b></li>
                <li><i>Subdomains are accepted</i>: <b>player.invintus.com</b></li>
            </ul>
        </Modal.Header>

        <Modal.Body>
            <DomainManager
                actions={props.actions}
                clientID={props.clientID}
                eventID={props.event.eventID}
                restrictedDomains={props.event.restrictedDomains}/>
        </Modal.Body>

        <Modal.Footer>
            <button className="btn btn-danger" onClick={e => {
                props.deleteAll(e)
                props.toggleModal(e)
            }}>
                Remove All
            </button>
            <button className="btn btn-primary" onClick={props.toggleModal}>
                Close
            </button>
        </Modal.Footer>

    </Modal>
}

export default RestrictionsModal